import React, { Component } from "react";
import dynamicPortal from "../utils/dynamicPortal";
import Departures from "../components/Haltes/Departures";
import Disruptions from "../components/Dienstregeling/Disruptions";

export class HalteDeparturesPortal extends Component {
  render() {
    return dynamicPortal.load(".js-react-halte-departures", (config) => {
      return (
        <React.Fragment>
          <Disruptions config={config.disruptionsConfig} />
          <Departures config={config.departuresConfig} />
        </React.Fragment>
      );
    });
  }
}

export default HalteDeparturesPortal;



// WEBPACK FOOTER //
// ./src/portals/HalteDeparturesPortal.js